module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-level-1-e057a46c7afb468358e0050d85a02dc9.svg";